import { useState } from 'react';
import { Path } from 'react-hook-form';


interface SelectOption {
  value: string;
  label: string;
}


interface SelectOption {
  value: string;
  label: string;
}


interface MultiSelectProps<T> {
  name: Path<T>;
  options: SelectOption[];
  handleMultiSelectChange: (selectedValues: string[], name: string) => void;
  value: string[];
  label: string;
  tooltip?: string;
}

export type MultiSelectI<T = any> = React.FC<MultiSelectProps<T>>

export const GenericMultiSelect: MultiSelectI = ({
  name,
  options,
  handleMultiSelectChange,
  value,
  label,
  tooltip,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const onChange = (e: any) => {
    const selected = Array.from(e.target.selectedOptions).map(
      (option: any) => option.value
    );
    handleMultiSelectChange(selected, name);
  };

  return (
    <div className="sm:my-4">
      <label className="my-2 block text-sm font-medium text-gray-700">
        {label}
        {tooltip && (
          <span
            className="relative inline-block ml-1"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="inline h-4 w-4 text-gray-400 cursor-help" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
            {showTooltip && (
              <span className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-1 w-64 p-2 text-xs font-normal text-white bg-gray-800 rounded shadow-lg">
                {tooltip}
              </span>
            )}
          </span>
        )}
      </label>
      <select
        multiple
        value={value}
        onChange={onChange}
        className="w-4/5 block shadow-sm sm:text-sm rounded-md"
      >
        {options.map((option: SelectOption, i: number) => (
          <option
            key={i}
            value={option.value}
            className="px-4 py-2 text-gray-700 sm:text-sm rounded-md cursor-pointer hover:text-gray-900 hover:bg-gray-100 transition duration-300 ease-in-out focus:outline-none"
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};
